import styled from 'styled-components'

export const PartnerModalWrapper = styled.div`
  .Partner-Modal__Title {
    color: ${p => p.theme.webMktPalette.text.primaryBlack};
    font-weight: 800;
    line-height: 44px;
    font-size: 36px;
  }
  .Partner-Modal__Description {
    margin: 32px 0 24px 0;
    color: ${p => p.theme.webMktPalette.grayCold[65]};
    font-size: 16px;
    line-height: 24px;
  }
`
export const consentTitle = styled.h1`
  color: rgb(53, 60, 74);
  font-size: 16px;
  font-weight: bold;
  height: 20px;
  letter-spacing: 0px;
  line-height: 20px;
  width: 80%;
  display: inline-table;
`

export const consentDescription = styled.h1`
  color: rgb(53, 60, 74);
  font-size: 14px;
  font-weight: normal;
  height: 72px;
  letter-spacing: 0px;
  line-height: 24px;
  width: 100%;
  overflow: scroll;
`

export const notificationsRow = styled.div`
  width: 100%;
  padding: 10px;
`

export const notificationsColumnLeft = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 0.5;
`

export const notificationsColumnRight = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 3;
`

export const notificationsLoader = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`
